export const getStoredAuthToken = () => {
  if (typeof window === 'undefined') {
    return undefined;
  }

  const token = localStorage.getItem('authToken');
  return token || undefined;
};
